import { DDL } from "../ddl";

export class CAQuestion {
    public QuestionID: number = -1;
    public QuestionHeader: string = '';
    public QuestionBody: string = '';
    public HelpText: string = "";
    public QuestionAnswers: DDL[] = [];
    public QuestionTypeID: number = -1;
    public IsRequired: boolean = false;
    public AnswerIDs: number[] = [];
    public AnswerText: string = '';
    public Notes: string = '';
    public Seq: number = -1;
    public GUID:string = '';
    public IsAnswered:boolean = false;
    public HasViewed:boolean = false;
    public AllowNA:boolean = false;
    public AllowComments:boolean = false;
    public NASelected:boolean = false;
    constructor(values: Object = {}) {
        Object.assign(this, values);
        if (values.hasOwnProperty('QuestionAnswers')) {
            this.QuestionAnswers = [];
            ((values as CAQuestion)['QuestionAnswers'] as DDL[]).forEach(element => {
                this.QuestionAnswers.push(new DDL(element));
            });
        }
    }
}